
import AdvertisingMasterImportForm from './AdvertisingMasterImportForm';

export default AdvertisingMasterImportForm;
